globalThis.Lang = globalThis.Lang || {};

if (typeof moment !== 'undefined') {
  var locale = globalThis.Lang.dateRangePicker.locale || 'fr';

  moment.locale(locale, globalThis.Lang.dateRangePicker.t('moment'));
  moment.locale(locale);
}

globalThis.DateRangePicker = (function() {
  function DateRangePicker($html, data, options, callback) {
    var data = data || {};

    if($html.length) {
      this.$html     = $html;
      this.config    = options;
      this.startDate = data.start_date;
      this.endDate   = data.end_date;
      this.minDate   = data.min_date;
      this.maxDate   = data.max_date;
      this.callback  = callback;
      this.init();
    }
  }

  DateRangePicker.prototype = {
    init: function() {
      var self = this;

      this._formatRanges();

      this.$html.daterangepicker($.extend({
        startDate: moment(this.startDate),
        endDate: moment(this.endDate),
        locale: {
          firstDay: 1,
          format: 'DD/MM/YYYY',
          applyLabel: Lang.dateRangePicker.t('apply'),
          cancelLabel: Lang.dateRangePicker.t('cancel'),
          customRangeLabel: Lang.dateRangePicker.t('customizedPeriod'),
          daysOfWeek: Lang.dateRangePicker.t('moment.weekdaysShort'),
          monthNames: Lang.dateRangePicker.t('moment.months')
        }
      }, this.config), function(start, end) {
        if(typeof self.callback == 'function') {
          self.callback(start, end);
        } else {
          window.location.href = window.location.protocol + '//' + window.location.hostname + window.location.pathname + '?from=' + start.format('YYYY-MM-DD') + '&to=' + end.format('YYYY-MM-DD')
        }
      });
    },
    _formatRanges: function() {
      this.$html.find('span').html(moment(this.startDate).format('LL') + ' - ' + moment(this.endDate).format('LL'));
    }
  }

  return DateRangePicker;
})();
